import React from 'react';
import {
    utils,
    writeFile
} from 'xlsx';
// props: Array<any>, cabecalho?: Array<string>, descCorpo?: Array<string>
export default function OpenExcelUniversal(Membros?: Array<any>, Props?: any[]) {
    let wb = utils.book_new();
    let ws = (e: any) => utils.json_to_sheet(e);
    const returnCampusNecess = Membros?.map((e: any) => {
        let a = Props?.map(Element => {
            return {
                [Element]: e[Element]
            }
        })
        return Object.assign({}, ...a ?? [])
    });

    let membrosTotal = Membros?.map((e: any) => e = 1).reduce((a, b) => a + b, 0);
    utils.book_append_sheet(wb, ws(returnCampusNecess), "MySheet1");
    utils.sheet_add_aoa(ws(returnCampusNecess), [[membrosTotal]], { origin: -1 });
    writeFile(wb, "MyExcel.xlsx");
}
